import React, { useState, useEffect } from "react"
import styled from "styled-components"

export let Proposito = props => {
  return (
    <>
      <section style={{ backgroundColor: "#9286D1" }} id="section-donate">
        <RowPro
          style={{
            justifyContent: "center",
            marginTop: "2rem",
            paddingBottom: "4rem",
            paddingTop: "4rem",
          }}
        >
          <RowText>
            <h1 style={{ fontSize: "3rem" }}>Evento con propósito</h1>
            <p>
              Con tu inscripción estarás ayudando a familias chilenas afectadas
              por el COVID-19.<br></br> El 100% del valor de la inscripción será
              donado a TECHO Chile para la compra de Kits de alimentación
            </p>
            <p>
              A veces un pequeño gesto, significa todo para alguien más.
              Regístrate donando un monto <b>mínimo de 5 USD</b>.
            </p>
          </RowText>
        </RowPro>
      </section>
    </>
  )
}

const RowPro = styled.div`
  padding-left: 80px;
  padding-right: 80px;
  @media (max-width: 502px) {
    padding-left: 20px;
    padding-right: 20px;
  }
`

const RowText = styled.div`
  margin-right: auto;
  margin-left: auto;
  justify-content: center !important;
  width: 100%;

  p {
    text-align: center !important;
    font-size: 1.4rem;
    color: #ffffff;
  }
  h1 {
    text-align: center !important;
    color: white;
  }
  h2 {
    text-align: center !important;
    font-family: "Poppins", sans-serif;
    font-size: 1.5rem !important;
  }
  a {
    color: white;
    font-family: "Poppins", sans-serif;
    font-size: 1.5rem !important;
    font-weight: bold;
  }
`

const Title = styled.h2`
  font-family: "Poppins", sans-serif;
  font-weight: 700;
  line-height: 1.2;
  padding-top: 2rem;
  padding-bottom: 3rem;
  font-size: 3rem;
  text-align: center;
  margin-top: 4rem;
  @media (max-width: 600px) {
    font-size: 2rem;
    padding-bottom: 2rem;
  }
  @media (max-width: 400px) {
    font-size: 1.3rem;
    margin-top: 2rem;
    padding-bottom: 1rem;
  }
`
const SubTitle = styled.h4`
  font-family: "Poppins", sans-serif;
  text-align: center;
  margin-bottom: 4rem;
  @media (max-width: 600px) {
    font-size: 1.3rem;
  }
`
export default Proposito
